import React, { useEffect, useRef, useState } from 'react'
import { convertToKebabCase } from '../../utils'
import Icon from '../icon'
import * as s from './styles'
import Button from '../button'

export type Subitem = {
  text?: string
  event?: () => void
  disabled?: boolean
  isDanger?: boolean
}

type Props = {
  'data-qa'?: string
  children?: any
  disabled?: boolean
  event?: () => void
  isLoading?: boolean
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void
  style?: object
  subitems?: Subitem[]
  theme?: 'primary' | 'secondary'
  title?: string
  type?: 'button' | 'submit'
  displayOnTop?: boolean
}

const ButtonDropdown: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = props.theme
  const dataQa = composeDataQa(props)
  const [toggle, setToggle] = useState<boolean>(false)

  function getIconName(): string {
    return props.displayOnTop
      ? toggle
        ? 'keyboard_arrow_down'
        : 'keyboard_arrow_up'
      : toggle
      ? 'keyboard_arrow_up'
      : 'keyboard_arrow_down'
  }

  const ref = useRef(null)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setToggle(false)
    }
  }

  return (
    <s.ContainerButton ref={ref}>
      <Button
        theme={classes}
        style={props.style}
        disabled={props.disabled}
        type={props.type}
        data-qa={dataQa}
        onClick={() => setToggle(!toggle)}
      >
        {props.title}
        <s.TextSpacer>
          <Icon name={getIconName()} />
        </s.TextSpacer>
      </Button>

      {toggle && (
        <s.Submenu length={props.displayOnTop ? props.subitems?.length : null}>
          {props.subitems?.map((subitem, key) => (
            <s.Subitem
              onClick={() => {
                subitem.event()
                setToggle(false)
              }}
              key={key}
              disabled={subitem.disabled}
            >
              <s.ActionLink
                disabled={subitem.disabled}
                isDanger={subitem.isDanger}
              >
                {subitem.text}
              </s.ActionLink>
            </s.Subitem>
          ))}
        </s.Submenu>
      )}
    </s.ContainerButton>
  )
}

ButtonDropdown.defaultProps = {
  theme: 'primary',
  type: 'button',
}

export default ButtonDropdown

function composeDataQa(props: Props): string {
  const buttonName = props.children || 'buttonDropdown'

  const id = props['data-qa'] || convertToKebabCase(buttonName?.toString())

  return `button-${id}`
}
